import React from "react";

const SortIcon = ({ active, dir }) => (
    <span className="ml-1 inline-flex flex-col leading-none">
        <span className={`text-[9px] ${active && dir === 'asc' ? 'text-warm-800' : 'text-warm-300'}`}>▲</span>
        <span className={`text-[9px] ${active && dir === 'desc' ? 'text-warm-800' : 'text-warm-300'}`}>▼</span>
    </span>
);

const Menu = ({ sortBy, sortDir, onSort }) => {
    const th = (label, column) => (
        <th
            className="px-4 py-3 text-left text-xs font-semibold text-warm-600 uppercase tracking-wide cursor-pointer select-none hover:text-warm-800 transition-colors"
            onClick={() => onSort(column)}
        >
            <span className="inline-flex items-center gap-0.5">
                {label}
                <SortIcon active={sortBy === column} dir={sortDir} />
            </span>
        </th>
    );

    return (
        <thead>
            <tr className="bg-warm-100 border-b border-warm-200">
                {th('Title', 'title')}
                {th('Author', 'author')}
                <th className="px-4 py-3 text-left text-xs font-semibold text-warm-600 uppercase tracking-wide">Genre</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-warm-600 uppercase tracking-wide">Synopsis</th>
                {th('Rating', 'rating')}
                {th('Progress', 'progress')}
                <th className="px-4 py-3"></th>
            </tr>
        </thead>
    );
};

export default Menu;
